'use strict';

function Agency (object) {
  this.id = object.get('id');
  this.name = object.get('name');
  this.uri = object.get('uri');
  this.path = object.get('path');
  this.typeName = object.get('typeName') || 'Агентство';
}

Agency.prototype.getId = function () {
  return this.id;
};

Agency.prototype.getName = function () {
  return this.name;
};

Agency.prototype.getType = function () {
  return this.typeName;
};

Agency.prototype.getUri = function () {
  return this.uri;
};

export default Agency;



// WEBPACK FOOTER //
// ./src/classes/common/agency.js